@let iconResponse = getSignal('icon')();
@let titleResponse = getSignal('title')();
@let subtitleResponse = getSignal('subtitle')();

<div class="container">
    @if(iconResponse.success && titleResponse.success && subtitleResponse.success) {

        <app-editable-image 
        [elemId]="iconResponse.payload"
        [imageReference]="imageReference"
        [fileTypes]="supportedFileTypes"
        [maxWidth]="200"
        [maxHeight]="120"
        [customClass]="'feature-banner-custom-class-image'">
    </app-editable-image>
    <div class="text-container">
        <app-editable-text 
            [customClass]="'custom-title-medium'"
            [elemId]="titleResponse.payload">
        </app-editable-text>    
        <app-editable-text 
        [customClass]="'custom-label-medium'"
            [elemId]="subtitleResponse.payload">
        </app-editable-text>
    </div>
}
</div>